// Desktop hover-expand accordion for the 5 version panels.
// (Uses JS rather than CSS :has() for broader browser support.)
(function () {
  function init() {
    var root = document.querySelector('[data-version-selector]');
    if (!root) return;
    var panels = root.querySelectorAll('[data-panel]');
    if (!panels.length) return;

    function setActive(active) {
      panels.forEach(function (p) {
        if (window.innerWidth < 768) {
          p.style.flexGrow = '';
          return;
        }
        if (!active) {
          p.style.flexGrow = '1';
        } else if (p === active) {
          p.style.flexGrow = '1.8';
        } else {
          p.style.flexGrow = '0.6';
        }
      });
    }

    panels.forEach(function (p) {
      p.addEventListener('mouseenter', function () { setActive(p); });
      p.addEventListener('focus', function () { setActive(p); });
    });
    root.addEventListener('mouseleave', function () { setActive(null); });

    setActive(null);
    window.addEventListener('resize', function () { setActive(null); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
